var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlowerHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29305",
    "data-name": "Group 29305",
    transform: "translate(-1302 11226.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(1302 -11226.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29292",
    "data-name": "Group 29292",
    transform: "translate(1008 -11531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49779",
    "data-name": "Path 49779",
    d: "M27.626,13.981c-4.507,7.807-11.361-4.063-2.346-4.063-9.015,0-2.162-11.87,2.346-4.063-4.507-7.807,9.2-7.807,4.691,0,4.507-7.807,11.361,4.063,2.346,4.063,9.015,0,2.162,11.87-2.346,4.063C36.825,21.788,23.119,21.788,27.626,13.981Z",
    transform: "translate(290.136 311)",
    fill: "#ff728b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49780",
    "data-name": "Path 49780",
    d: "M34.922,9.913l-4.572-.061,0,0h0l2.227-3.992c4.507-7.807-9.2-7.807-4.691,0l2.228,3.993h0l0,0-4.571.082c-9.015.03-2.122,11.877,2.359,4.055l2.33-3.933,0,0,0,0,2.349,3.923C37.1,21.78,43.937,9.9,34.922,9.913Z",
    transform: "translate(289.877 311)",
    fill: "#ff3f62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49781",
    "data-name": "Path 49781",
    d: "M92.778,159.2a.3.3,0,0,0-.3.3v1.275a.3.3,0,1,0,.607,0V159.5a.3.3,0,0,0-.3-.3Zm-4.821-9.766.782.649a.3.3,0,0,0,.388-.467l-.782-.649a.3.3,0,1,0-.388.467Zm-.475,6.138-1.122.608a.3.3,0,1,0,.289.534l1.122-.608a.3.3,0,1,0-.289-.534Zm10.762,1.935-.809-.721a.3.3,0,1,0-.4.453l.809.721a.3.3,0,0,0,.4-.453Z",
    transform: "translate(227.33 167.872)",
    fill: "#ff0c38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49782",
    "data-name": "Path 49782",
    d: "M111.537,57.018l-4.668-1.653,4.728-2.986a.3.3,0,1,0-.324-.514l-4.792,3.026v-4.53a.3.3,0,1,0-.607,0V54.8l-2.567-2.13a.3.3,0,1,0-.388.467l1.738,1.443L100.54,53.1a.3.3,0,0,0-.2.572l5.1,1.827-3.254,1.762a.3.3,0,1,0,.289.534l3.395-1.838,0,4.667a.3.3,0,0,0,.3.3h0a.3.3,0,0,0,.3-.3l0-4.512,3.171,2.828a.3.3,0,1,0,.4-.453l-2.514-2.242,3.8,1.346a.3.3,0,0,0,.2-.573Zm-5.359-7.77a.3.3,0,0,0,.3-.3V47.663a.3.3,0,1,0-.607,0v1.282a.3.3,0,0,0,.3.3Z",
    transform: "translate(213.937 265.476)",
    fill: "#ff0c38"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_401",
    "data-name": "Ellipse 401",
    cx: 2.368,
    cy: 2.368,
    rx: 2.368,
    ry: 2.368,
    transform: "translate(317.747 318.549)",
    fill: "#ffeb99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49783",
    "data-name": "Path 49783",
    d: "M196.206,197.241a2.369,2.369,0,0,1,1.768-2.291,2.368,2.368,0,1,0,0,4.583A2.369,2.369,0,0,1,196.206,197.241Z",
    transform: "translate(122.742 123.677)",
    fill: "#ffda44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerHighlighted);
export default __webpack_public_path__ + "static/media/flowerHighlighted.09451adf248432b41b284aabf8401733.svg";
export { ForwardRef as ReactComponent };